import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { Table, TableDataRowProps, TableProps } from "../../../../Common/UI/Index";
import { ALL, CONFIGURED, NOT_CONFIGURED } from "./Constants";
import "../../../OutputConfig/Style.scss";

interface FinalOutputListViewProps {
  /**
   * Table data as list
   */
  list: TableProps;
}

export const FinalOutputListView: React.FC<FinalOutputListViewProps> = (props: FinalOutputListViewProps) => {
  const { list } = props;
  const { t: translate } = useTranslation();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const { finalOutputFilterBy } = outputConfig;
  const [filteredList, setFilteredList] = useState(list);
  const configuredStatus = ["Configured"];
  const notConfiguredStatus = ["Not Configured", "Missing", "Extra", "Internal"];

  /**
   * To set filtered list when original list changes
   */
  useEffect(() => {
    setFilteredList(list);
  }, [list]);

  /**
   * To filter out the data
   * @param matchBy compare with
   * @returns the list
   */
  const getFilteredData = (matchBy: string): TableDataRowProps[] => {
    const filterBy = matchBy === CONFIGURED ? configuredStatus : notConfiguredStatus;
    const data = [...list.dataRow];
    const filteredData = data.filter((item: TableDataRowProps) => item &&
      filterBy.includes(item["row"] &&
        item["row"][2] &&
        item["row"][2]["value"] &&
        item["row"][2]["value"]["props"] &&
        item["row"][2]["value"]["props"]["children"]));
    return filteredData;
  };

  /**
   * To set filtered list when filter by changes
   */
  useEffect(() => {
    let filteredList: TableProps;
    if (finalOutputFilterBy === ALL) {
      filteredList = Object.assign({}, list);
    } else if (finalOutputFilterBy === CONFIGURED) {
      filteredList = { ...list, dataRow: getFilteredData(CONFIGURED) };
    } else {
      filteredList = { ...list, dataRow: getFilteredData(NOT_CONFIGURED) };
    }
    setFilteredList(filteredList);
  }, [finalOutputFilterBy]);

  return (
    <div className="ebt-finaloutput-container__output-list-view">
      {
        filteredList && filteredList.headerRow.length > 0 ?
          <Table
            id="ebt-outputConfig-finalOutput-table"
            tableData={filteredList}
            emptyStateText={translate("OutputConfig.FinalOutputTable.NoEntries")}
          /> :
          <div
            className="center-text"
            id="ebt-outputConfig-finalOutput-message"
          >
            {translate("OutputConfig.FinalOutputTable.NoEntries")}...
            {translate("OutputConfig.FinalButtons.RunHealthCheck")}
          </div>
      }
    </div>
  );
};
